<template>
  <router-view
    :name="isMobile ? 'mobile' : 'default'"
  ></router-view>
</template>
<script>
import { mapState } from 'vuex';

    export default {
      name: "defaultWrapper",
      computed: {
        ...mapState(['isMobile'])
      },
    };
</script>
